import axios from 'axios';

const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('casinoiq_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401 && !window.location.pathname.includes('/login') && !window.location.pathname.includes('/signup') && window.location.pathname !== '/' && !window.location.pathname.includes('/terms') && !window.location.pathname.includes('/privacy') && !window.location.pathname.includes('/viral-tools/gambler-personality-quiz') && !window.location.pathname.includes('/viral-tools/friend-challenge') && !window.location.pathname.includes('/share/')) {
      localStorage.removeItem('casinoiq_token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default api;
